import { ClientPortfolioDomainEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { EditBusinessLoansForm } from "web_myplann/Portfolio/Pages/BusinessLoansEdit/EditBusinessLoansForm";
import { PortfolioEditLayout } from "web_myplann/Portfolio/PortfolioShared/PortfolioEditLayout";

export const EditBusinessLoansPage = () => {
	const { t } = useResource();

	return (
		<PortfolioEditLayout
			expectedDomain={ClientPortfolioDomainEnum.BusinessLoans}
			title={t(Resources.Portfolio.EditPortfolio.title)}
		>
			{({ portfolio, portfolioId, detailRoute }) => (
				<EditBusinessLoansForm
					portfolioId={portfolioId}
					portfolio={portfolio}
					detailRoute={detailRoute}
				/>
			)}
		</PortfolioEditLayout>
	);
};
